import * as action from './actions';

import * as actionTypes from './actionTypes';

import { InferValueTypes } from 'types/commonTypes';
import { BigScreenStoreType } from './types';

export const initialState: BigScreenStoreType = {
    bigScreenDeepLink: null,
    socketMessage: null,
    bigScreenToken: null,
    bigScreenExercises: null,
    initialStartTime: 0,
    signature: null,
    bigScreenSessionId: null,
    bigScreenTokenTTL: null,
    yogaType: null,
    bigScreenBgAudio: null,
};

type ActionType = ReturnType<InferValueTypes<typeof action>>;

const bigScreenReducer = (state: BigScreenStoreType = initialState, action: ActionType): BigScreenStoreType => {
    switch (action.type) {
        case actionTypes.GET_BIG_SCREEN_DEEP_LINK_SUCCESS:
            return {
                ...state,
                bigScreenDeepLink: action.payload.url,
                bigScreenToken: action.payload.token,
                signature: action.payload.signature,
                bigScreenTokenTTL: action.payload.bigScreenTokenTTL,
            };

        case actionTypes.SET_SOCKET_MESSAGE:
            return { ...state, socketMessage: action.payload };

        case actionTypes.SET_BIG_SCREEN_START_DATA:
            return {
                ...state,
                bigScreenExercises: action.payload.exercises,
                bigScreenSessionId: action.payload.companion_mode_session_id,
                initialStartTime: action.payload.progress_time,
                yogaType: action.payload.yoga_type,
                bigScreenBgAudio: action.payload.bg_audio,
            };

        case actionTypes.RESET_BIG_SCREEN_START_DATA:
            return {
                ...state,
                bigScreenExercises: initialState.bigScreenExercises,
                bigScreenSessionId: initialState.bigScreenSessionId,
                initialStartTime: initialState.initialStartTime,
                yogaType: initialState.yogaType,
                bigScreenBgAudio: initialState.bigScreenBgAudio,
            };

        default:
            return state;
    }
};

export default bigScreenReducer;
